export default __webpack_public_path__ + "static/media/icon-dashboard.b66def0f.svg";